export function OrganizationDefaultFormDownloadLink({
  label,
  disabled,
  busy,
  onClick,
}: {
  label: string
  disabled: boolean
  busy: boolean
  onClick: () => void
}) {
  return (
    <div className="mt-2">
      <button
        type="button"
        disabled={disabled || busy}
        className="cursor-pointer bg-transparent p-0 text-sm text-blue-600 underline hover:text-blue-800 disabled:cursor-not-allowed disabled:opacity-60"
        onClick={onClick}
      >
        {busy ? 'Opening…' : label}
      </button>
    </div>
  )
}
